import { TillageChip } from '@cibo/ui'
import { DetailSimpleCellProps } from '../types'

export const TillageSimpleCell = ({ detail }: DetailSimpleCellProps) => {
  return <TillageChip type={detail?.result} source={detail?.source} />
}
